// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import { assign } from 'lodash';

const TAXONOMY_TOPICS = {
  ac: 'Amortization',
  col: 'Home Search',
  cl: 'Home Search',
  hac: 'Buying a Home',
  hifc: 'Home Improvement Loans',
  mc: 'Mortgage Process',
  mpc: 'Mortgage payment',
  rc: 'Managing Your Mortgage',
  rvb: 'Rent or Buy',
};

/**
 * Create taxonomy object for provided calc
 * @param {String} calc Which calculator to get taxonomy for; 'hac', 'mc' or 'rc'
 * @returns {Array}
 */
export default function getTaxonomy(calc) {
  // Remove after migration to bedrock, need for old pipeline
  return [
    { nwVarName: 'vertical', bkVarName: 'vertical', value: 'Mortgages' },
    { nwVarName: 'topic', bkVarName: 'topic', value: TAXONOMY_TOPICS[calc] },
    { nwVarName: 'pageType', bkVarName: 'pageType', value: 'Learn' },
    { nwVarName: 'contentType', bkVarName: 'contentType', value: 'Calculator' },
  ];
}

/**
 * Resolves a taxonomy array to an object usable by trk-helper
 * @param {String} calc Which calculator to get taxonomy for; 'hac', 'mc' or 'rc'
 * @returns {Object}
 */
export function getTaxonomyObject(calc) {
  return getTaxonomy(calc).reduce(
    (acc, taxonomyItem) =>
      assign(acc, {
        [taxonomyItem.nwVarName]: taxonomyItem.value,
      }),
    {}
  );
}
